import { Dispatch, SetStateAction, useState } from 'react';
import { AnimatedTab, SidebarModal } from '../../../components';
import { PurchaseEarnBetSteps } from '../EarnBet.types';
import { AnimatePresence } from 'framer-motion';
import { ConfirmDeposit } from './ConfirmDeposit';
import { SelectPayment } from './SelectPayment';
import { OrderConfirmation } from './OrderConfirmation';
import { EarnBetHub } from '../EarnBetHub/EarnBetHub';
import Spinner from '../../../components/common/Spinner';
import { useAppSelector } from '../../../app/hooks';
import { EarnBetTransfer } from '../../Earnings/TranferToEarnBet/Transfer.types';

interface PaymentInitProps {
  modal: boolean;
  setModal: Dispatch<SetStateAction<boolean>>;
  transferStep: number;
  setTransferStep: Dispatch<SetStateAction<number>>;
  price: number;
}

export const PaymentInit = ({
  setModal,
  modal,
  transferStep,
  setTransferStep,
  price
}: PaymentInitProps) => {
  const { loading, userEarnbetTopup } = useAppSelector(
    (state) => state.earnings
  );

  const handleSidebarTitle = (step: PurchaseEarnBetSteps) => {
    switch (step) {
      case PurchaseEarnBetSteps.CONFIRM_DEPOSIT:
        return 'Confirm Deposit';
      case PurchaseEarnBetSteps.SELECT_PAYMENT:
        return 'Select Payment';
      case PurchaseEarnBetSteps.ORDER_CONFIRMATION:
        return 'Order Confirmation';
      default:
        return '';
    }
  };

  const renderTitle = handleSidebarTitle(transferStep);

  return (
    <SidebarModal
      isOpen={modal}
      sidebarWidth={'650px'}
      setOpen={(v) => {
        setModal(v);
      }}
      title={renderTitle}>
      <>
        {userEarnbetTopup?.currencyType !== 3 && <EarnBetHub price={price} />}
        {loading && <Spinner absolute transparent />}
        <AnimatePresence exitBeforeEnter>
          {transferStep === PurchaseEarnBetSteps.CONFIRM_DEPOSIT && (
            <AnimatedTab key={PurchaseEarnBetSteps.CONFIRM_DEPOSIT}>
              <ConfirmDeposit setTransferStep={setTransferStep} price={price} />
            </AnimatedTab>
          )}

          {transferStep === PurchaseEarnBetSteps.SELECT_PAYMENT && (
            <AnimatedTab key={PurchaseEarnBetSteps.SELECT_PAYMENT}>
              <SelectPayment setTransferStep={setTransferStep} price={price} />
            </AnimatedTab>
          )}

          {transferStep === PurchaseEarnBetSteps.ORDER_CONFIRMATION && (
            <AnimatedTab key={PurchaseEarnBetSteps.ORDER_CONFIRMATION}>
              <OrderConfirmation />
            </AnimatedTab>
          )}
        </AnimatePresence>
      </>
    </SidebarModal>
  );
};
